import * as classnames from 'classnames'
import * as React from 'react'

import TrendingSash from '../../../components/trendingSash'
import { IItemCard } from '../interface'
import Preview from '../lockupPreview'
import LockupPreviewActionPanel from '../lockupPreviewActionPanel'
import LockupTags from '../lockupTags'

import * as styles from './itemCardLandscapePreview.module.css'

interface IProps extends IItemCard {
  carousel?: boolean
}

const ItemCardLandscapePreview = (props: IProps) => {
  const {
    item,
    onItemLinkClick,
    isCardHovered,
    rank,
    viewType,
    carousel = false
  } = props
  const { tags = '', term = '' } = props.locationParams

  const rootClass = classnames({
    [styles.listView]: viewType === 'list',
    [styles.isCardHovered]: isCardHovered
  })

  return (
    <section className={rootClass}>
      {item.trending && <TrendingSash lazy large />}
      <Preview
        item={item}
        rank={rank}
        onItemLinkClick={onItemLinkClick}
        carousel={carousel}
      />
      <div className={classnames(styles.previewTags)}>
        <LockupTags item={item} tags={tags} term={term} />
      </div>
      <section className={styles.hoverOverlay}>
        <a
          href={`${item.url}?s_rank=${rank}`}
          onClick={onItemLinkClick}
          className={styles.hoverOverlayClickHandler}
          role="toolbar"
          title={item.name}
        />
        <section className={styles.hoverOverlayActions}>
          <LockupPreviewActionPanel {...props} />
        </section>
      </section>
    </section>
  )
}

export default ItemCardLandscapePreview
